<template lang="html">
  <div id="lifestyles-page">

    <section class="placed-backg banner-section-s1" v-bind:style="{ backgroundImage: 'url(public/images/pages/contact/bg.png)' }">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-6 col-xl-5 col-titles">
            <h1 class="mb-3 title">{{ $t("lyfestyles.title") }}</h1>

            <h6 class="title-sl-1"><span>{{ $t("lyfestyles.subtitle") }}</span></h6>
          </div>

          <div class="col-lg-5 col-xl-4 col-info">
            <p>{{ $t("lyfestyles.description") }}</p>
          </div>

          <div class="col-lg-1 col-xl-2 col-bg">
            <div class="bg-color"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="container oversized-container gallery-section">
      <div class="row">
        <div class="col-sm-6 col-lg-4 col-image" v-for="(l, lInx) in lifestyles" :key="'lInx-'+lInx">
          <router-link class="placed-backg btn-image" v-bind:style="{ backgroundImage: 'url('+ l.imageUrl + ')' }"  :to="'/lifestyles/'+l.id">
            <img src="/public/images/pages/lifestyles/image.png" alt="Image">

            <div class="inside">
              <div class="box">{{ $i18n.locale == 'en' ? l.name  : l.name_es  }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      lifestyles: [
        /*{ name: 'Beach' },
        { name: 'Country living' },
        { name: 'Eco Friendly' },
        { name: 'Equastrian' },
        { name: 'Lakefront' },
        { name: 'Metropolitan' },*/
      ]
    }
  },
  methods: {
    getLifestyles() { // Obtener la info de la BD
      this.$root.modal_loading = true;
      axios.get(tools.url("/api/lifestyles")).then((response)=>{
        this.lifestyles = response.data;
        this.$root.modal_loading = false;
      });
    },
  },
   //insert the following code for vue-meta to work
   metaInfo() {
    return {
      meta: [
        { name: 'og:title', content: this.$root.seoadata.lifestyles.meta_title},
        { name: 'og:description', content: this.$root.seoadata.lifestyles.meta_description	},
        { name: 'og:keywords', content: this.$root.seoadata.lifestyles.meta_keywords},
      ]
    }
  },
  mounted(){
    this.getLifestyles();
  },
}
</script>

